import { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

// Sticks the app bar to the top after the user scrolls past 20px on
// non-mobile screens; mobile is always sticky. Encapsulates a pattern
// every quote/compare/summary screen used to repeat inline.
export const useAppBarSticky = () => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [isAppBarFixed, setIsAppBarFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!isXsScreen) {
        setIsAppBarFixed(window.scrollY > 20);
      } else {
        setIsAppBarFixed(true);
      }
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isXsScreen]);

  return { isAppBarFixed, isXsScreen };
};
